<template>
  <div
    class="fixed inset-0 bg-[rgba(0,0,0,0.4)] z-[1111] flex justify-end overflow-y-auto"
    id="popup-content"
    @click.self="closeModal"
  >
    <div
      class="relative w-full lg:w-[80%] max-h-screen bg-[#f8f8f8] px-[12px] py-[30px] md:p-[40px] overflow-auto"
    >
      <div class="shadow-none bg-transparent">
        <div class="flex items-start justify-between">
          <p class="text-[#353535] text-[20px] leading-[20px] font-semibold">
            Viewing Returns ID - {{ returnID ? returnID : 2112140663 }}
          </p>
          <button
            class="text-2xl text-[#353535] outline-none focus:outline-none"
            type="button"
            @click="closeModal"
          >
            <span class="mdi mdi-close"></span>
          </button>
        </div>
      </div>

      <!-- top header -->
      <div class="bg-white p-[24px] rounded-[4px] mt-[16px]">
        <p
          v-if="returnDetailsiisActive"
          class="text-[#353535] text-[20px] leading-[20px] font-semibold"
        >
          Intialize Returns
        </p>
        <div
          v-if="returnListDetails.length > 0 && !returnDetailsiisActive"
          class="mt-[16px]"
        >
          <p class="text-medium text-[16px] leading-[20px] text-[#353535]">
            You are returning products from Order #{{
              returnListDetails[0].orderNumber
            }}
          </p>
          <div class="flex items-center w-full max-w-[500px] mt-[10px]">
            <h2
              class="font-medium text-[14px] text-[#353535] leading-[20px] w-full"
            >
              Customer Name on order
            </h2>
            <span
              class="font-normal text-[14px] text-[#353535] leading-[24px] px-[14px] py-[12px] w-full rounded-[8px] block w-full"
            >
              {{ returnListDetails[0].customer }}
            </span>
          </div>
          <div class="flex items-center gap-[24px] w-full mt-[10px]">
            <h2 class="font-medium text-[14px] text-[#353535] leading-[20px]">
              Returned Status
            </h2>
            <span
              :class="[
                'badge flex items-center gap-[8px]',
                {
                  'badge-warning': returnListDetails[0].action == 0,
                  'badge-success': returnListDetails[0].action == 1,
                  'badge-danger': returnListDetails[0].action == 2,
                },
              ]"
            >
              <span
                class="w-[10px] h-[10px] rounded-[1px]"
                :style="{
                  backgroundColor:
                    returnListDetails[0].action == 0
                      ? '#F6C23E'
                      : returnListDetails[0].action == 1
                      ? '#16A249'
                      : '#EF5253',
                }"
              ></span>
              {{
                returnListDetails[0].action == 2
                  ? "Reversed"
                  : actionsList
                      .filter((x) => x.id == returnListDetails[0].action)
                      .map((x) => x.label)[0]
              }}
            </span>
          </div>
        </div>
      </div>

      <!-- returned items -->
      <div v-if="returnDetailsiisActive" class="mt-[16px]">
        <div class="float-right">
          <button
            @click="addProduct"
            class="border-[1px] bg-[#2463eb] rounded-[8px] text-white border-solid px-[16px] sm:px-[24px] text-[14px] md:text-[14px] py-[10px] outline-none focus:outline-none mb-[16px]"
          >
            Add Product
          </button>
        </div>

        <div class="table-responsive">
          <table class="table text-nowrap">
            <thead class="bg-[#ECF9FF]">
              <tr>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Product Name
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Product Code
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Quantity Returned
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Order Number
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Action
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Location
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(oR, index) in returnItemDetails" :key="index">
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  {{ oR.productName }}
                </td>
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  {{ oR.productCode }}
                </td>
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  {{ oR.productQuantityReturned }}
                </td>
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  {{ oR.productOrderNumber }}
                </td>
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  {{ oR.productAction }}
                </td>
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  {{ oR.productLocation }},
                  {{ oR.productwarehouseLocation }}
                </td>
                <td>
                  <button
                    class="btn-no-border"
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <span
                      class="text-[#98a2b3] dropdown text-2xl cursor-pointer relative outline-none active:outline-none shadow-none"
                    >
                      ...
                    </span>
                  </button>
                  <ul
                    class="dropdown-menu shadow-none"
                    aria-labelledby="dropdownMenuButton"
                  >
                    <li
                      class="text-[14px] font-normal leading-[14px] text-[#353535] cursor-pointer py-[10px] px-[16px] border-b"
                      @click.prevent="editReturnsData(oR)"
                    >
                      Edit
                    </li>
                    <li
                      class="text-[14px] font-normal leading-[14px] text-[#DC2828] cursor-pointer py-[10px] px-[16px]"
                      @click.prevent="deleteReturns(oR.productOrderNumber)"
                    >
                      Delete
                    </li>
                  </ul>
                </td>
              </tr>
              <tr v-if="returnItemDetails.length == 0">
                <td colspan="9">
                  <div class="text-center" style="padding-top: 50px">
                    <span
                      style="font-size: 4.615rem"
                      class="mdi mdi-tag-multiple"
                    ></span>
                  </div>
                  <h3 class="text-center" style="padding-bottom: 100px">
                    You don't have any customer returns.
                  </h3>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="float-right">
          <div>
            <div class="flex items-center justify-center gap-[8px] mt-[16px]">
              <button
                class="border-[1.5px] border-solid border-[#96a0b5] rounded-[8px] text-[#96a0b5] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] py-[10px] outline-none focus:outline-none"
                @click="cancelCustomerReturns"
              >
                Cancel
              </button>
              <button
                :disabled="load"
                class="border-[1px] bg-[#2463eb] rounded-[8px] text-white border-solid px-[16px] sm:px-[24px] text-[14px] md:text-[14px] py-[10px] outline-none focus:outline-none disabled:cursor-not-allowed"
                @click="completeReturns"
              >
                {{ load ? "Loading..." : "Complete Returns" }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- returnedlists -->
      <div v-if="returnDetails">
        <div class="table-responsive mt-[16px]">
          <table class="table text-nowrap">
            <thead class="bg-[#ECF9FF]">
              <tr>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Product Code
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Product Name
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Quantity Returned
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Order Number
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Action
                </th>
                <th
                  class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                >
                  Location
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody class="bg-white">
              <tr v-for="(RD, index) in returnListDetails" :key="index">
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  {{ RD.code }}
                </td>
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  {{ RD.description }}
                </td>
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  {{ RD.quantity }}
                </td>
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  {{ RD.orderNumber }}
                </td>
                <td>
                  <span
                    :class="[
                      { 'text-warning': RD.action == 0 },
                      { 'text-success': RD.action == 1 },
                      { 'text-danger': RD.action == 2 },
                    ]"
                  >
                    {{
                      RD.action == 2
                        ? "Reversed"
                        : actionsList
                            .filter((x) => x.id == RD.action)
                            .map((x) => x.label)[0]
                    }}
                  </span>
                </td>
                <td
                  class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                >
                  {{ RD.storageArea }},{{ RD.wareHouse }}
                </td>
                <td>
                  <button
                    v-if="RD.action == 0 || RD.action == 1"
                    class="btn-no-border"
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <span
                      class="text-[#98a2b3] dropdown text-2xl cursor-pointer relative outline-none active:outline-none shadow-none"
                    >
                      ...
                    </span>
                  </button>
                  <ul
                    v-if="RD.action == 0 || RD.action == 1"
                    class="dropdown-menu px-1"
                    aria-labelledby="dropdownMenu2"
                  >
                    <div>
                      <li
                        class="text-[14px] font-normal leading-[14px] text-[#353535] cursor-pointer py-[10px] px-[16px]"
                        @click.prevent="ReverseModal(RD.id, 'Reverse')"
                      >
                        Reverse
                      </li>
                    </div>
                  </ul>
                </td>
              </tr>
              <tr v-if="returnListDetails.length == 0">
                <td colspan="9">
                  <div class="text-center" style="padding-top: 50px">
                    <span
                      style="font-size: 4.615rem"
                      class="mdi mdi-tag-multiple"
                    ></span>
                  </div>
                  <h3 class="text-center" style="padding-bottom: 100px">
                    You don't have any customer returns.
                  </h3>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    "returnItemDetails",
    "returnListDetails",
    "closeModal",
    "isBusy",
    "load",
    "returnID",
    "completeReturns",
    "cancelCustomerReturns",
    "returnDetailsiisActive",
    "returnDetails",
    "editReturnsData",
    "deleteReturns",
    "returnAnotherProductFromThisOrder",
    "addProduct",
    "actionsList",
    "ReverseModal",
  ],
};
</script>
